import styled, { css } from 'styled-components';
import { Colors, toRem } from '.';

const Item = styled.div<{ selected?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 0 .5rem 0rem;
    color: #546077;
    cursor: pointer;
    font-weight: 400;
    user-select: none;

    &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: .25rem;
        background: none;
    }

    &:hover {
        &:after { background: ${Colors.primaryLight}; }
        color: ${Colors.primaryLight};
    }
    &:active {
        &:after { background: ${Colors.primary}; }
        color: ${Colors.primaryText};
    }
    ${p => !p.selected ? '' : css`
        &:after { background: ${Colors.primary}; }
        color: ${Colors.primaryText};
    `}
`;

type PopupTabsProps = {
    border?: string,
    padding?: string | number,
    spacing?: string | number,
    minWidth?: number,
    size?: 'md' | 'lg',
};

const Base = styled.div<PopupTabsProps>`
    display: flex;
    flex-direction: row;
    border-bottom: ${p => p.border ?? 'solid 1px #F0F2F5'};
    padding: ${p => !!p.padding ? toRem(p.padding) : '.375rem 0 0 0'};
    font-size: ${p => p.size === 'md' ? '1rem' : '1.125rem'};
    
    ${Item} {
        min-width: ${p => p.minWidth ?? 0}rem;
        margin-right: ${p => toRem(p.spacing ?? 2)};
    }
`;

export const PopupTabs = Object.assign(Base, { Item });


